import { useState, useCallback, useMemo, useEffect } from 'react'

import { 
    Box, Pagination, PaginationItem, Stack
} from '@mui/material'

import { ArrowBack, ArrowForward } from '@mui/icons-material'

import { getPaginate } from 'services/utils'
//import { useUser } from 'services/StateContext'

//import api from 'services/methods/profissional'
//import apiUser from '../services/methods/user'

import { toast } from 'react-toastify'
//import Modal from '../Components/Modal'
import Loading from 'Components/Loading'
import Title from 'Components/Title'
import config from '../../../static/Profissional'
//import { useNavigate } from 'react-router-dom'
import Back from 'Components/Back'
import { useHistory } from 'Components/useHistory'
import { CardItem } from 'Components/CardItem'
import { usePatient } from 'Components/usePatientContext'
import api from 'lib/api_clinica'

const style = { 
    py: 2,
    display: 'flex',
    gap: 2,
    flexWrap: 'wrap',
}

const Profissional = () => {
    
    const [ perfis , setPerfis  ] = useState([]) 
    
    const { 
        agenda, 
        patient, 
        loading, 
        setLoading 
    } = usePatient()

    const { diaEscolhido }    = agenda
    const { historyPaths }    = useHistory()

    historyPaths.add('/profissional')

    const getDias = useCallback( async () => { 
        
        try {

            setLoading(true)
            
            // const response = await api.getHorariosConsultaMensal(patient)
            
            // if (response.status === -1) { 
            //     throw response
            // }

            // const items = getItems(response) 

            // const perfis = await api.getPerfis({items, diaEscolhido})

            const perfis = await api.profissionais.get({...patient, diaEscolhido})
            
            setPerfis(perfis)

        } catch (error) {
            toast.error('Ocorreu um erro ao listar os dias')     
        } finally {
            
            setLoading(false)
        }
        // eslint-disable-next-line
    }, [ setPerfis, setLoading])
    

    useEffect(() => {
        getDias()
    }, [getDias])

    const PerfisPagination = () => {

        const perfisPagination = useMemo( () => getPaginate(perfis, 9, 0), [])

        if (!perfisPagination || perfisPagination.length === 0 || perfisPagination.length <= 9) {
            return ''
        }

        return <Stack spacing={2} >
            <Pagination
                onChange={ (_, page) => {
                    const items = getPaginate(perfisPagination, 9, (page -1))
                    setPerfis(items)
                }}
                count={Math.ceil(perfisPagination?.length / 9)}
                renderItem={(item) => (
                    <PaginationItem
                        components={{ previous: ArrowBack, next: ArrowForward }}
                        {...item}
                    />
                )}
            />
        </Stack>
    }
    
    
    
    return <>
        <Title title={config.title} />
        <Box sx={{...style}} > 
            {perfis?.map( (item, i) => <CardItem 
                    key={i} 
                    id={item.idProfissional} 
                    nome={item.nomeProfissional}
                    horarios={item.horarios} 
                    data={item.dataAgenda}
                    

                />) 
            }
        </Box> 
        <PerfisPagination />
        <Back loading={loading} />
        {loading && <Loading />}
    </>
}

export default Profissional